/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S7_P3Inputs */

const en_guide_json_syntax_errors_s7_p3 = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the data comes from an API and still will not parse, check that you are looking at the response body and not the headers, and that it was not truncated in transit. Copying the raw payload into a validator removes any doubt about what the parser actually received.`)
};

const ko_guide_json_syntax_errors_s7_p3 = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데이터가 API에서 왔는데도 파싱되지 않는다면, 헤더가 아니라 응답 본문을 보고 있는지, 전송 중 잘리지 않았는지 확인하세요. 원시 페이로드를 검증기에 붙여넣으면 파서가 실제로 무엇을 받았는지 의심의 여지가 사라집니다.`)
};

const ja_guide_json_syntax_errors_s7_p3 = /** @type {(inputs: Guide_Json_Syntax_Errors_S7_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データが API から来ていてもパースできないなら、ヘッダーではなくレスポンス本文を見ているか、転送中に切れていないかを確認しましょう。生のペイロードを検証ツールに貼り付ければ、パーサーが実際に何を受け取ったかについての疑いが消えます。`)
};

/**
* | output |
* | --- |
* | "If the data comes from an API and still will not parse, check that you are looking at the response body and not the headers, and that it was not truncated in..." |
*
* @param {Guide_Json_Syntax_Errors_S7_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s7_p3 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S7_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S7_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s7_p3(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s7_p3(inputs)
	return ja_guide_json_syntax_errors_s7_p3(inputs)
});